import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=5815c3ac"
import script from "./CreateCustomer.vue?vue&type=script&lang=ts"
export * from "./CreateCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports